"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopiaButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
function TopiaButton(props) {
    return ((0, jsx_runtime_1.jsx)("button", { type: props.type || "button", onClick: function () {
            // if (props.analyticsEvent) {
            //   trackAnalyticsEvent(props.analyticsEvent);
            // }
            props.onClick && props.onClick();
        }, disabled: props.loading, style: __assign({ 
            // minWidth: 180,
            borderRadius: 50, height: 50, border: props.btnStyle !== "link" ? "1px solid #1d1e20" : undefined }, props.style), className: (0, classnames_1.default)("align-center inline-flex items-center justify-center py-2 px-6 text-center  font-medium focus:outline-none focus:ring-2 focus:ring-offset-2", !props.btnStyle || props.btnStyle === "primary"
            ? "bg-pale-yellow text-topia-black"
            : "", props.btnStyle === "future" &&
            "bg-future-blue text-black focus:ring-gray-500", props.btnStyle === "secondary" && "", props.className, props.btnStyle === "black" && "bg-topia-black text-white"), children: (0, jsx_runtime_1.jsx)("p", { className: (0, classnames_1.default)("m-auto text-sm", props.pClassName), children: props.loading ? "Loading..." : props.children }) }));
}
exports.TopiaButton = TopiaButton;
